import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function BreathingCircle() {
  const [phase, setPhase] = useState("Inspire");

  useEffect(() => {
    const seq = [
      { label: "Inspire", ms: 4000 },
      { label: "Retiens", ms: 2000 },
      { label: "Expire", ms: 4000 },
      { label: "Repos", ms: 2000 },
    ];
    let i = 0;
    let timeout;
    const tick = () => {
      setPhase(seq[i].label);
      timeout = setTimeout(() => {
        i = (i + 1) % seq.length;
        tick();
      }, seq[i].ms);
    };
    tick();
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center">
      <motion.div
        data-testid="breathing-circle"
        className="em-breath"
        animate={{
          scale: [1, 1.35, 1.35, 1, 1],
          opacity: [0.85, 1, 1, 0.85, 0.85],
        }}
        transition={{
          duration: 12,
          times: [0, 0.33, 0.5, 0.83, 1],
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <span className="text-xl">{phase}</span>
      </motion.div>
      <p className="mt-6 text-sm text-slate-400 max-w-sm text-center">
        4 secondes pour inspirer, 2 pour tenir, 4 pour expirer, 2 pour relâcher. Reste ici
        quelques cycles — ton corps va se calmer tout seul.
      </p>
    </div>
  );
}
